
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sss",
      function () {
        return require("private-next-pages/sss/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sss"])
      });
    }
  